import { FC } from 'react';
import { OtpValidationTemplate } from '../templates';

export const OtpValidationPage: FC = () => {
  return (
    <OtpValidationTemplate />
  )
}
